export function makeSerializeEdits({ vmClient, getLocalMap, getRemoteMap, serializeShared }) {
  return (state, type, id) => {
    const remote = getRemoteMap(state);
    const local = getLocalMap(state);
    return vmClient.serializeEdits(local, remote, type, id, {
      serializeShared: serializeShared === undefined ? false : serializeShared,
    });
  };
}
